import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

const bps = DtvTheme.breakpoints;
export const DropdownListStyles = ({ showDrawer, showDrawerNoMatch }) => ({
  root: {
    width: "100%",
    transition: "height 0.3s ease-in-out",
    marginTop: {
      xs: "4px",
      md: "8px"
    },
    transform: "translateX(-50%)",
    zIndex: 1011,
    position: "absolute",
    left: "50%",
    backgroundColor: colorPalette.neutral_white.main,
    borderRadius: "8px",
    maxHeight: "0px",
    padding: "0px"
  },
  container: {
    width: "100%",
    position: "relative",
    overflowY: "scroll",
    overflowX: "hidden",
    borderRadius: "8px",
    "::-webkit-scrollbar": {
      width: "8px"
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "darkgrey",
      borderRadius: "8px"
    },
    "::-webkit-scrollbar-track": {
      borderRadius: "8px" // Match the border radius of the container
    },
    boxShadow: "0 2px 12px 0 rgba(0, 4, 67, 0.16), 0 1px 0 0 rgba(255, 255, 255, 0.30) inset, 0 -1px 0 0 rgba(0, 0, 0, 0.12) inset",
    maxHeight: "0px",
    padding: "0px",
    backgroundColor: colorPalette.neutral_white.main,
    ...((showDrawer || showDrawerNoMatch) && {
      maxHeight: "290px", // 12px (outer padding) +  42px * 4
      [bps.up(bps.values.md)]: {
        maxHeight: "386px"
      },
      padding: "8px 0 4px 0 !important"
    })
  },
  menuUi: {
    width: "100%",
    padding: "0",
    margin: "0",
    overflow: "auto",
    backgroundColor: colorPalette.neutral_white.main,
    borderRadius: "6px"
  },
  menuli: {
    cursor: "pointer",
    padding: "8px 16px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    backgroundColor: colorPalette.neutral_white.main,
    color: "#102641 !important"
  },
  menuP: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    lineHeight: "20.8px !important",
    fontSize: "16px !important",
    fontWeight: 400,
    color: "#102641 !important"
  }
})
